import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Perfil() {
  const [userData, setUserData] = useState(null);
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const user = localStorage.getItem('unet_user');
    if (user) {
      const data = JSON.parse(user);
      setUserData(data);
      setFormData(data);
    }
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem('unet_user', JSON.stringify(formData));
    setUserData(formData);
    setEditing(false);
  };

  if (!userData) return <div className="loading">Carregando...</div>;

  return (
    <div className="perfil-page">
      <div className="container">
        <div className="page-header">
          <h1>Meu Perfil</h1>
          <p>Gerencie suas informações pessoais</p>
        </div>

        <div className="perfil-grid">
          <div className="perfil-card">
            <div className="card-header">
              <h3>Informações Pessoais</h3>
              <button 
                onClick={() => setEditing(!editing)} 
                className="btn-edit"
              >
                {editing ? 'Cancelar' : 'Editar'}
              </button>
            </div>
            
            {editing ? (
              <form onSubmit={handleSubmit} className="perfil-form">
                <div className="form-group">
                  <label>Nome Completo</label>
                  <input
                    type="text"
                    name="nome"
                    value={formData.nome || ''}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>E-mail</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email || ''}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Telefone</label>
                  <input
                    type="tel"
                    name="telefone"
                    value={formData.telefone || ''}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Endereço</label>
                  <input
                    type="text"
                    name="endereco"
                    value={formData.endereco || ''}
                    onChange={handleChange}
                  />
                </div>
                <button type="submit" className="btn-primary">Salvar</button>
              </form>
            ) : (
              <div className="perfil-info">
                <div className="info-item">
                  <span className="label">Nome:</span>
                  <span className="value">{userData.nome}</span>
                </div>
                <div className="info-item">
                  <span className="label">E-mail:</span>
                  <span className="value">{userData.email}</span>
                </div>
                <div className="info-item">
                  <span className="label">Telefone:</span>
                  <span className="value">{userData.telefone || 'Não informado'}</span>
                </div>
                <div className="info-item">
                  <span className="label">Endereço:</span>
                  <span className="value">{userData.endereco || 'Não informado'}</span>
                </div>
              </div>
            )}
          </div>

          <div className="perfil-card">
            <h3>Informações da Conta</h3>
            <div className="perfil-info">
              <div className="info-item">
                <span className="label">ID do Cliente:</span>
                <span className="value">{userData.id}</span>
              </div>
              <div className="info-item">
                <span className="label">Plano Atual:</span>
                <span className="value">{userData.plano}</span>
              </div>
              <div className="info-item">
                <span className="label">Status:</span>
                <span className="value status-ativo">{userData.status}</span>
              </div>
              <div className="info-item">
                <span className="label">Vencimento:</span>
                <span className="value">{userData.vencimento}</span>
              </div>
            </div>
          </div>

          <div className="perfil-card">
            <h3>Ações da Conta</h3>
            <div className="acoes-lista">
              <Link to="/central/alterar-senha" className="acao-item">
                <i className="fas fa-key"></i>
                <span>Alterar Senha</span>
              </Link>
              <Link to="/central/notificacoes" className="acao-item">
                <i className="fas fa-bell"></i>
                <span>Configurar Notificações</span>
              </Link>
              <Link to="/central/faturas" className="acao-item">
                <i className="fas fa-file-invoice"></i>
                <span>Histórico de Faturas</span>
              </Link>
              <Link to="/central/suporte" className="acao-item">
                <i className="fas fa-headset"></i>
                <span>Suporte</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Perfil; 